<template>
  <div>

    <vs-table pagination max-items="10" :data="history">

      <template slot="header">
        <h5>Total forward orders using the RM: {{total_orders}}</h5>
      </template>

      <template slot="thead">
        <vs-th>EXP MANUFACTURE DATE</vs-th>
        <vs-th>ORDER DATE</vs-th>
        <vs-th>ORDER VALUE IN KG</vs-th>
        <vs-th>NUM OF CUSTOMER ORDERS</vs-th>
        <vs-th>ORDER NUMBERS</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].expiry_manu_day">
            {{ data[indextr].expiry_manu_day }}
          </vs-td>

          <vs-td :data="data[indextr].order_date">
            {{ data[indextr].order_date }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{toFixedNumbers(data[indextr].quantity)}}
          </vs-td>

          <vs-td :data="data[indextr].orders">
            {{ data[indextr].orders }}
          </vs-td>

          <vs-td :data="data[indextr].order_nos">
            <span class="text-sm font-semibold text-primary" v-for="no in data[indextr].order_nos" :key="Math.random() + no.id">
              <a :href="`/pages/product-orders/${no.id}`">{{no.product_order_code}}</a>,
              <a :href="`/pages/formulations/${no.formulation.id}`" v-if="no.formulation" target="_blank">{{no.formulation.formulation_code}}</a>,
            </span>
          </vs-td>

        </vs-tr>
      </template>

    </vs-table>
  </div>
</template>

<script>
  export default {
    name: "ProductOrderTable",
    props: {
      history: {
        type: Array,
        default: []
      },
      total_orders: {
        type: String,
        default: '0'
      }
    },
    methods: {
      toFixedNumbers(number) {
        return (Number(number)).toFixed(2)
      }
    }
  }
</script>

<style scoped>

</style>
